import { SubtleMonochromeLink } from '@liveauctioneers/hammer-ui-core/link';
import { BodySecondary, H5 } from '@liveauctioneers/hammer-ui-core/text';

import { CatalogCardDate } from '@/components/CatalogCard/components/CatalogCardDate/CatalogCardDate';
import { useAppSelector } from '@/redux/hooks';
import {
    getCatalogIsSEOExcluded,
    getCatalogSellerId,
    getCatalogSellerName,
    getCatalogTitle,
} from '@/redux/modules/catalog/catalogs/catalog.selectors';
import { AuctionCardClickedTrigger } from '@/utils/amplitude/analytics/catalog/trackAuctionCardClicked.analytics';
import { useAppFormatMessage } from '@/utils/intl/useAppFormatMessage';
import { getCatalogUrl, getSellerUrl } from '@/utils/urls';

type Props = {
    catalogId: number;
};

export const HomepageAuctionCardDetails = ({ catalogId }: Props) => {
    const formatMessage = useAppFormatMessage();
    const isSEOExcluded = useAppSelector((state) => getCatalogIsSEOExcluded(state, catalogId));
    const sellerId = useAppSelector((state) => getCatalogSellerId(state, catalogId));
    const sellerName = useAppSelector((state) => getCatalogSellerName(state, catalogId));
    const title = useAppSelector((state) => getCatalogTitle(state, catalogId));

    const catalogUrl = getCatalogUrl(catalogId, title);
    const rel = isSEOExcluded ? 'nofollow' : '';

    return (
        <>
            <SubtleMonochromeLink
                data-testid="homepage-auction-card-title"
                data-track-trigger={AuctionCardClickedTrigger.TitleClick}
                href={catalogUrl}
                rel={rel}
            >
                <H5 className="truncate">{title}</H5>
            </SubtleMonochromeLink>
            <BodySecondary className="flex gap-2xs truncate whitespace-nowrap">
                <span>{formatMessage(['catalog_card', 'homepage', 'by'])}</span>
                <SubtleMonochromeLink
                    className="truncate"
                    data-track-trigger={AuctionCardClickedTrigger.HouseNameClick}
                    href={getSellerUrl(sellerId, sellerName)}
                    size="sm"
                >
                    {sellerName}
                </SubtleMonochromeLink>
            </BodySecondary>
            <CatalogCardDate
                catalogId={catalogId}
                className="pr-0"
            />
        </>
    );
};
